export default "__VITE_ASSET__8b79c860__"